import { createAction } from 'redux-actions';

export const setOpmServiceStatusForBanner = createAction(
  'SET_OPM_SERVICE_STATUS_FOR_BANNER',
);

export const resetOpmServiceStatusForBanner = createAction(
  'RESET_OPM_SERVICE_STATUS_FOR_BANNER',
);
